import { Card } from "antd";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import formatMoney from "../../../utils/formatMoney";
import { MetricInfo, buildMetricDocs, TIME_FIELD_LABELS } from "./dashboard-metric-info";
import { getChartTheme } from "../../../theme/chart-theme";
import { useThemeMode } from "../../../theme/theme-provider";

// Format large VND numbers to short labels on Y axis
function formatYAxis(value) {
    if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(0)}M`;
    if (value >= 1_000) return `${(value / 1_000).toFixed(0)}K`;
    return value;
}

function DashboardRevenueChart({ data, timeField = "purchase" }) {
    // recharts nhận màu qua prop, không ăn theo antd ConfigProvider hay class CSS
    const { isDark } = useThemeMode();
    const chart = getChartTheme(isDark);
    const docs = buildMetricDocs(timeField);
    return (
        <Card
            title={
                <span className="flex items-center gap-1.5 flex-wrap">
                    Doanh thu theo ngày (30 ngày gần nhất)
                    <span className="text-xs font-normal text-content-3">
                        — {TIME_FIELD_LABELS[timeField].toLowerCase()}
                    </span>
                    <MetricInfo doc={docs.revenueChart} />
                </span>
            }
            className="shadow-sm"
        >
            {data.length === 0 ? (
                <div className="flex items-center justify-center h-48 text-content-3 text-sm">
                    Chưa có dữ liệu
                </div>
            ) : (
                <ResponsiveContainer width="100%" height={260}>
                    <LineChart
                        data={data}
                        margin={{ top: 5, right: 20, bottom: 5, left: 0 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" stroke={chart.grid} />
                        <XAxis
                            dataKey="date"
                            tick={{ fontSize: 11, fill: chart.axis }}
                            tickLine={false}
                            stroke={chart.axis}
                            interval="preserveStartEnd"
                        />
                        <YAxis
                            tickFormatter={formatYAxis}
                            tick={{ fontSize: 11, fill: chart.axis }}
                            tickLine={false}
                            axisLine={false}
                            stroke={chart.axis}
                            width={48}
                        />
                        <Tooltip
                            formatter={(value, name) => [formatMoney.format(value), name]}
                            contentStyle={{
                                background: chart.tooltipBg,
                                border: `1px solid ${chart.tooltipBorder}`,
                                borderRadius: 8,
                            }}
                            labelStyle={{ color: chart.tooltipText }}
                            itemStyle={{ color: chart.tooltipText }}
                        />
                        <Legend wrapperStyle={{ color: chart.axis }} />
                        <Line
                            type="monotone"
                            dataKey="totalCommission"
                            stroke={chart.series[1]}
                            name="Tổng HH"
                            dot={false}
                            strokeWidth={2}
                            activeDot={{ r: 4 }}
                        />
                        <Line
                            type="monotone"
                            dataKey="totalUserCommission"
                            stroke={chart.series[2]}
                            name="User HH"
                            dot={false}
                            strokeWidth={2}
                            activeDot={{ r: 4 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            )}
        </Card>
    );
}

export default DashboardRevenueChart;
